import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import useRevealOnScroll from "../../../hooks/useRevealOnScroll";
import { FaQuoteLeft, FaStar, FaCheckCircle, FaUserCircle } from "react-icons/fa";

const testimonials = [
  {
    id: 1,
    name: "Awa Dieng",
    image: "/images/user1.png",
    comment:
      "Excellente qualité et livraison rapide. Je recommande vivement JamaalStore !",
  },
  {
    id: 2,
    name: "Moussa Niang",
    image: "/images/user2.png",
    comment:
      "Service client très professionnel. Les parfums sont authentiques.",
  },
  {
    id: 3,
    name: "Bineta Ly",
    image: "/images/user3.png",
    comment:
      "J'adore la variété des produits et les prix sont raisonnables.",
  },
  {
    id: 4,
    name: "Cheikh Ndiaye",
    image: "/images/user4.png",
    comment: "Les promotions sont juste incroyables !",
  },
  {
    id: 5,
    name: "Khadija Ndaw",
    image: "/images/user5.png",
    comment: "JamaalStore est devenu Top1 pour mes achats de parfums.",
  },
];

const Testimonials = () => {
  const { ref, revealed } = useRevealOnScroll(0.15);
  return (
    <section
      ref={ref}
      className={`bg-gradient-to-b from-gray-50 to-gray-100 py-16 transition-transform duration-700 ease-out transform opacity-0 ${
        revealed ? "opacity-100 translate-y-0" : "translate-y-8"
      }`}
    >
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-800">Témoignages de nos clients</h2>
          <p className="text-gray-600 mt-1">Ce que disent nos clients à propos de JamaalStore</p>
        </div>

        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          loop={true}
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="pb-10"
          style={{ ["--swiper-theme-color"]: "#1e40af" }}
        >
          {testimonials.map((t) => (
            <SwiperSlide key={t.id}>
              <div className="relative overflow-hidden rounded-2xl shadow-lg bg-gradient-to-br from-blue-800 to-blue-700 p-6 mx-2 bg-blue-100 transform transition duration-500 hover:shadow-2xl">
                <FaQuoteLeft className="absolute -top-2 -left-2 text-green-400 w-12 h-12" />
                <div className="flex flex-col items-center text-center">
                  <div className="relative">
                    <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center ring-4 ring-blue-300/40 text-blue-700">
                      <FaUserCircle className="w-16 h-16" />
                    </div>
                   
                  </div>
                  <h3 className="mt-1 text-lg font-semibold text-blue-800">{t.name}</h3>
                  <div className="mt-1 flex items-center gap-1 text-yellow-700">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                  <p className="text-blue-800 italic mt-3 leading-relaxed">"{t.comment}"</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
